document.addEventListener("DOMContentLoaded", () => {
    let viewGeneral = document.querySelector(".contacto-page")
    if(viewGeneral == null){
        return;
    }

    let form = document.querySelector("#formContacto")
    let btnSubmit = form.querySelector(".btn-submit");
    form.addEventListener("submit", function (e) {
        e.preventDefault();
        let datos = new FormData(form);
        btnSubmit.disabled = true;
        axios.post('/contacto', datos).then(function (respuesta) {
            btnSubmit.disabled = false;
            if (respuesta.data.error) {
                Alerta(respuesta.data.error, "info");
            } else {
                form.reset();
                Alerta(respuesta.data.mensaje, "success");
            }
        })["catch"](function (error) {
            console.log(error);
            btnSubmit.disabled = false;
            Alerta("Ocurrió un error inesperado", "info");
        });
    });
})




